import { ModalContext } from 'app/app';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { Icon, ViewContext } from 'components/lib';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import Loader from './images/loader.gif';
import styles from './styles.module.scss';
import InputUtils from 'helpers/inputUtils';

export function ContactModal() {
  const { id: company_id } = useParams();
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState('');

  const api_error = false;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('This field is required!'),
    date_of_birth: Yup.date(),
    email: Yup.string().email('Invalid email!'),
    phone: Yup.string().min(14, 'Number format invallid.'),
    notes: Yup.string(),
  });

  const inputUtils = new InputUtils();
  const handleChangePhoneNumber = (event, handleChange) => {
    handleChange(event);
    setPhone(inputUtils.number(event.target.value, phone));
  };

  useEffect(() => {
    if (modal.data && modal.data.phone) {
      setPhone(modal.data.phone);
    } else {
      setPhone('');
    }
  }, [modal]);

  return (
    <Fragment>
      {modal.name === 'contact_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit'
                  ? 'Edit Contact'
                  : 'Add Contact'}
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  name:
                    modal.data && modal.data.name
                      ? modal.data.name
                      : '',
                  date_of_birth:
                    modal.data && modal.data['Date Of Birth']
                      ? new Date(modal.data['Date Of Birth'])
                          .toISOString()
                          .substring(0, 10)
                      : '',
                  email:
                    modal.data && modal.data.email
                      ? modal.data.email
                      : '',
                  phone,
                  notes:
                    modal.data && modal.data.notes
                      ? modal.data.notes
                      : '',
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  if (values.date_of_birth !== '') {
                    var str = values.date_of_birth.split('-');
                    var formatedDate = new Date(
                      parseInt(str[0]),
                      parseInt(str[1]) - 1,
                      parseInt(str[2])
                    );

                    values.date_of_birth = formatedDate.toISOString();
                  }

                  if (modal.data) {
                    await axios
                      .patch(`/api/contact/${modal.data.id}`, {
                        name: values.name,
                        date_of_birth: values.date_of_birth,
                        email: values.email,
                        phone: values.phone,
                        notes: values.notes,
                        company_id,
                      })
                      .then((res) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          'Contact updated successfully!',
                          'success',
                          true,
                          'toast',
                          'check-circle'
                        );

                        modal.action();
                      })
                      .catch((err) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          err.response.data.message,
                          'error',
                          true,
                          'toast',
                          'x-circle'
                        );
                      });
                  } else {
                    await axios
                      .post(`/api/contact`, {
                        name: values.name,
                        date_of_birth: values.date_of_birth,
                        email: values.email,
                        phone: values.phone,
                        notes: values.notes,
                        company_id,
                      })
                      .then((res) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          'Contact created successfully!',
                          'success',
                          true,
                          'toast',
                          'check-circle'
                        );

                        modal.action();
                      })
                      .catch((err) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          err.response.data.message,
                          'error',
                          true,
                          'toast',
                          'x-circle'
                        );
                      });
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="name"
                          type="text"
                          label="Name"
                          placeholder="Name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.name}
                          touched={touched.name}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="email"
                          type="text"
                          label="Email"
                          placeholder="Email"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.email}
                          touched={touched.email}
                        />
                        <FieldInput
                          id="phone"
                          type="phone"
                          label="Phone"
                          placeholder="Phone"
                          handleChange={(event) => {
                            handleChangePhoneNumber(
                              event,
                              handleChange
                            );
                          }}
                          value={phone}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.phone}
                          touched={touched.phone}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="notes"
                          type="text"
                          label="Notes"
                          placeholder="Notes"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.notes}
                          touched={touched.notes}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={
                        api_error
                          ? { justifyContent: 'space-between' }
                          : { justifyContent: 'flex-end' }
                      }
                    >
                      {api_error && (
                        <div className={styles.errorMessage}>
                          <div className={styles.icon}>
                            <Icon image="alert-circle" />
                          </div>
                          <span>
                            Something went wrong, check the fields.
                          </span>
                        </div>
                      )}
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading && (
                            <img
                              src={Loader}
                              alt="loading"
                              style={{ width: '25px' }}
                            />
                          )}
                          {!loading && 'Save'}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
